import createAxiosInstance from './Axios';

export const callGetProductsFromOc = (oc, reCaptchaToken, baseURL) => {
  const axiosInstance = createAxiosInstance(baseURL);
  return axiosInstance({
    url: `/form/validation/productsByOc/${oc}`,
    method: 'get',
    headers: {
      reCaptchaToken: reCaptchaToken,
    },
  });
};
